const EXPORT_TYPE = {
  VESTING_HMC: {
    KEY: 'vesting_hmc',
    LABEL: 'Export Vesting HMC',
  },
  VESTING_VENTURE: {
    KEY: 'vesting_venture',
    LABEL: 'Export Vesting Ventures',
  },
  VESTING_HMC_2019: {
    KEY: 'vesting_hmc_2019',
    LABEL: 'Export Vesting 2019-2022',
  },
  VESTING_HMC_V2: {
    KEY: 'vesting_hmc_v2',
    LABEL: 'Export Vesting HMC V2',
  },
  VESTING_VENTURE_V2: {
    KEY: 'vesting_venture_v2',
    LABEL: 'Export Vesting Ventures V2',
  },
  ALL: {
    KEY: 'all',
    LABEL: 'Export All',
  },
}

export { EXPORT_TYPE }
